export interface Campaign {
    readonly id: bigint;
    readonly title: string;
    readonly description: string;
    readonly category: string;
    readonly icon: string;
    readonly goalBTC: number;
    readonly raisedBTC: number;
    readonly backers: number;
    readonly creatorAddress: string;
    readonly createdAtBlock: bigint;
    readonly durationDays: number;
    readonly active: boolean;
    readonly metadata: string;
    readonly isExample?: boolean;
}

export const CATEGORIES = [
    { value: 'Education', icon: '\u{1F4DA}' },
    { value: 'Open Source', icon: '\u{1F4BB}' },
    { value: 'Security', icon: '\u{1F512}' },
    { value: 'Infrastructure', icon: '\u{1F310}' },
    { value: 'Community', icon: '\u{1F91D}' },
    { value: 'Research', icon: '\u{1F52C}' },
    { value: 'Charity', icon: '\u{2764}\uFE0F' },
    { value: 'Art & Culture', icon: '\u{1F3A8}' },
    { value: 'Rescue', icon: '\u{1F6A8}' },
] as const;

export const EXAMPLE_CAMPAIGN: Campaign = {
    id: 0n,
    title: 'Bitcoin Education for Developing Nations',
    description:
        'This is an example campaign to show you how BitFund works. Create your own campaign by clicking the "+ Create Campaign" button above! Set a BTC goal, describe your idea, and share it with the world.',
    category: 'Education',
    icon: '\u{1F4DA}',
    goalBTC: 2.5,
    raisedBTC: 0,
    backers: 0,
    creatorAddress: '',
    createdAtBlock: 0n,
    durationDays: 30,
    active: true,
    metadata: '',
    isExample: true,
};
